/**
 * Ponto de entrada do protótipo.
 *
 * Usa navegação por histórico do navegador, e não por fragmento de URL: é o
 * mesmo mecanismo que a aplicação real usará quando servida pelo binário, e
 * adotá-lo agora evita que os caminhos mudem depois.
 */

import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MotionConfig } from "motion/react";
import { TooltipProvider } from "@cloudflare/kumo";
import { App } from "./App.js";
import { ThemeModeProvider } from "./components/ThemeMode.js";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("elemento raiz não encontrado no documento");
}

// `reducedMotion="user"` desliga as animações de entrada para quem pediu movimento
// reduzido no sistema — a tela continua completa, só sem o deslocamento.
createRoot(container).render(
  <StrictMode>
    <ThemeModeProvider>
      <TooltipProvider>
        <MotionConfig reducedMotion="user">
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MotionConfig>
      </TooltipProvider>
    </ThemeModeProvider>
  </StrictMode>,
);
